import { useNavigate } from "react-router-dom"
import { faqs } from "../helpers/constants"

const HelpCenter = () => {
    const navigate = useNavigate()
    return (
        <div className="p-4 w-full">
            <div className="flex justify-between items-center mb-5">
                <h1 className="text-4xl w-full h-full font-semibold">Help Center</h1>
                <button
                    onClick={() => navigate("/layout/issues")}
                    className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                >
                    View Issues
                </button>
            </div>
            <hr />
            <br />
            <p> Welcome to TSAW’s UTM (Unpiloted Traffic Management) platform for drones! If you encounter any technical issues, incidents, or have any queries related to our services, please don’t hesitate to contact our support team. You can raise a support request by sending an email to utm-support@tsaw.tech.</p><br />
            <p> Our support team is available 24/7 to assist you with any problems or questions you may have. When you email us, please provide as much detail as possible about the issue you are experiencing, including any error messages or steps to reproduce the problem. This will help us diagnose and resolve your issue more quickly.</p><br />
            <div className="mt-5">
                <h1 className="mt-6 w-full font-semibold text-4xl "> Frequently Asked Questions (FAQs) </h1><br />
                <hr /><br />
                {faqs.map((faq, index) => {
                    return (
                        <div key={index}>
                            <p className="font-semibold text-2xl"> {faq.question}</p>
                            <p className="text-base">{faq.answer} </p> <br />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default HelpCenter